import styled from 'styled-components';

export const Title = styled.h1`
	font-size: 1.25rem;
	font-weight: 600;
	margin-bottom: 1rem;
`;

export const Footer = styled.div`
	align-items: center;
	display: flex;
	gap: 0.75rem;
	justify-content: center;
	margin-top: 1.5rem;
`;

export const TicketSummary = styled.div`
	background: #f5f5f5;
	border-radius: 8px;
	margin-bottom: 1rem;
	padding: 0.75rem 1rem;
`;

export const SummaryName = styled.p`
	font-weight: 600;
	margin-bottom: 0.25rem;
`;

export const SummaryCode = styled.p`
	font-size: 0.875rem;
	text-transform: uppercase;
`;

export const Hint = styled.p`
	color: #5f5f5f;
	font-size: 0.875rem;
	margin-bottom: 1rem;
`;
